<template>
  <div class='searchTool'>
    <!-- @input="searchKeyWords" -->
    <el-input class='search-input' v-model="keyWords" placeholder="Please enter keywords" clearable @change="searchKeyWords"></el-input>
    <div class='search-btn' @click="searchKeyWords">Search</div>
  </div>
</template>
<script>
export default {
  name: 'searchTool',
  data() {
    return {
      keyWords: "",
    }
  },
  methods: {
    searchKeyWords() {
      const words = this.keyWords.trim()
      this.$emit("searchKeyWords", words)
    }
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>

.searchTool {
  display: flex;
  padding: 0px 0px;
  flex-direction: row;
  align-items: center;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin: 0px 13px;
  box-sizing: border-box;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  outline: 0;
  height: 25px;
  max-width: 280px;
}

.search-input {
  font-size: 12px;
}

.search-btn {
  font-size: 12px;
  height: 100%;
  min-width: 48px;
  // margin-left: px;
  cursor: pointer;
  background-color: #0052d9;
  color: #fff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.el-input__wrapper) {
  height: 20px;
  font-size: 12px;
  font-weight: 400;
  border: 0;
  font-size: 11px;
  padding-left: 10px;
  box-shadow:none !important;
}
</style>